import React from "react";

const DefaultTextbox = ({
  width = "100%",
  disabled = false,
  placeholder = "Enter value",
  value,
  onChange,
  rows = 4,
  ...props
}) => {
  return (
    <div
      className="py-[0.688em] bg-white px-3 flex items-center !border !border-main rounded-[0.625em]"
      style={{ width: width, opacity: disabled ? "0.7" : "1" }}
    >
      <textarea
        className="outline-none flex-grow"
        rows={4}
        placeholder={placeholder ?? "Enter Value"}
        value={value}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

export default DefaultTextbox;
